import Badge from './Badge';

export default {
  id: 'radial_5',
  title: 'Radial_5',
  colors: 3,
  animated: true,
  premium: true,
  BadgeComponentStateless: Badge
};
